<template>
    <div class="blogList-block-item-banner">
        <article class="globalBanner globalBanner--wide">

            <div class="globalBanner--wide-content">
                <div class="globalBanner--wide-text">
                    <h2 v-html="bookEnquiryBannerObject.bannerTitleWide"></h2>
                    <p v-html="bookEnquiryBannerObject.bannerTextWide"></p>
                    <div class="inline-buttons">
                        <a class="btn btn-primary" :href="bookEnquiryBannerObject.bannerCtaUrl" v-html="bookEnquiryBannerObject.bannerCtaText"></a>
                        <a class="btn btn-secondary" :href="bookEnquiryBannerObject.bannerCtaSecondaryUrl" v-html="bookEnquiryBannerObject.bannerCtaSecondaryText"></a>
                    </div>
                </div>
                <div class="globalBanner--wide-image">
                    <img :src="bookEnquiryBannerObject.bannerImageWide" />
                </div>
            </div>

        </article>
    </div>
</template>

<script setup>
import { ref } from 'vue';

const bookEnquiryBannerObject = ref(bookEnquiryBanner || {});

</script>